import styled from "styled-components";

import { SpinnerContainer } from "../spinner/spinner.styles";

export const BaseButton = styled.button`
  min-width: 165px;
  width: auto;
  height: 50px;
  letter-spacing: 0.5px;
  line-height: 50px;
  padding: 0 35px 0 35px;
  font-size: 15px;
  background-color: black;
  color: white;
  text-transform: uppercase;
  font-family: "Open Sans";
  font-weight: 500;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  &:hover {
    background-color: white;
    color: black;
    border: 1px solid black;
  }
`;

export const GoogleSignInButton = styled(BaseButton)`
  background-color: #4285f4;
  color: white;
  border: 1px solid #4285f4;

  &:hover {
    background-color: white;
    border: 1px solid #4285f4;
    color: #4285f4;
  }
`;
export const InvertedButton = styled(BaseButton)`
  background-color: white;
  color: black;
  border: 1px solid black;

  &:hover {
    background-color: black;
    color: white;
    border: none;
  }
`;

export const ButtonSpinner = styled(SpinnerContainer)`
  width: 30px;
  height: 30px;

  /* display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid rgba(195, 195, 195, 0.6);
  border-radius: 50%;
  border-top-color: #636767;
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  } */
`;

// .button-container {
//     min-width: 165px;
//     width: auto;
//     height: 50px;
//     letter-spacing: 0.5px;
//     line-height: 50px;
//     padding: 0 35px 0 35px;
//     font-size: 15px;
//     background-color: black;
//     color: white;
//     text-transform: uppercase;
//     font-family: 'Open Sans';
//     font-weight: 500;
//     border: none;
//     cursor: pointer;
//     display: flex;
//     justify-content: center;

//     &:hover {
//       background-color: white;
//       color: black;
//       border: 1px solid black;
//     }

//     &.google-sign-in {
//       background-color: #4285f4;
//       color: white;
//       border: 1px solid #4285f4;

//       &:hover {
//         background-color: white;
//         border: 1px solid #4285f4;
//         color: #4285f4;
//       }
//     }

//     &.inverted {
//       background-color: white;
//       color: black;
//       border: 1px solid black;

//       &:hover {
//         background-color: black;
//         color: white;
//         border: none;
//       }
//     }
//   }
